import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dw8ijelh: FaireBrandEntity = {
  token: "b_dw8ijelh",
  type: "brand",
  name: "Lucky Honeybee",
  avatarUrl:
    "https://cdn.faire.com/fastly/aabf77b5affc0286e6b732b59da129fb289c91121918b4359622d9c244cd322d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/03360ec620f9e8bab26e0959f9c303e290fcb16785748ca7ac403ff0493a3227.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/aabf77b5affc0286e6b732b59da129fb289c91121918b4359622d9c244cd322d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/03360ec620f9e8bab26e0959f9c303e290fcb16785748ca7ac403ff0493a3227.jpeg",
  location: "Jersey City, NJ, USA",
  minimumOrderDollars: 205,
  rating: 5,
  reviewCount: 20,
  isInsider: true,
  description:
    "Lucky Honeybee creates thoughtfully designed candles and apothecary goods. We've got an eye for the environment in every aspect of our practice: from domestically produced wax, to ethically sourced oils, to choosing recycled content for our packaging wherever possible. We pay attention to the details so you don’t have to. \nWe know life is hard. We make stuff that makes you feel good. Visit us at www.theluckyhoneybee.com or at our Gift Shop in Jersey City, NJ. \n\nPlease note, shipping quotes and lead times may vary from what is quoted by Faire. Message us if you have concerns! \n\nPrivate Label available, please send us a request for quote! ",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:02.548Z",
    importedBy: "entity-db-cli",
  },
};
